import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
    return (
        <div className="min-h-screen bg-[#060606] text-white flex items-center justify-center p-6" data-testid="checkout-cancel-page">
            <div className="max-w-lg w-full border border-white/10 bg-[#0f0f10] p-10 text-center">
                <XCircle className="mx-auto text-white/60" size={48} />
                <h1 className="text-3xl mt-6 font-semibold">Checkout canceled</h1>
                <p className="text-white/60 mt-3">No charge was made. You can try again anytime.</p>
                <div className="mt-8 flex gap-3 justify-center">
                    <Link to="/framework" className="px-5 py-3 border border-white/30" data-testid="cancel-framework">Framework</Link>
                    <Link to="/stringtheory" className="px-5 py-3 border border-white/30" data-testid="cancel-stringtheory">String Theory</Link>
                </div>
            </div>
        </div>
    );
}
